import styled from 'styled-components/macro';

export const TicketsPageStyled = styled.div`
  margin: 0.875rem 0.625rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin: 1rem 0.625rem;
    }

    ${theme.devices.desktop} {
      margin: 1.875rem 0.625rem;
    }
  `}
`;

export const MessageWrapStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2.5rem 0;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin: 6.25rem 0;
    }
  `}
`;
